<!-- <p>risk-analytics-container works!</p> -->
<div [ngClass]="{
    'risk-analytics-container':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'risk-analytics-container-mobile': screenSize == ScreenType.Mobile
  }">
  <section>
    <mat-grid-list [cols]="screenSize == ScreenType.Mobile ? 1 : 2" rowHeight="120px"><mat-grid-tile rowspan="3">
        <div [ngClass]="{
            'risk-analytics-counters':
              screenSize == ScreenType.Desktop ||
              screenSize == ScreenType.Tablet,
            'risk-analytics-counters-mobile': screenSize == ScreenType.Mobile
          }">
          <mat-grid-list cols="3" rowHeight="60px">
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Monthly Risk Score" | uppercase }}</h2>
                  <h4>Risk score of current month</h4>
                </div>
                <div>
                  <strong>
                    <h1>
                      {{ currentMonthRiskScore
                      }}<span><b><mat-icon style="color: red" *ngIf="
                              currentMonthRiskScore >= previousMonthRiskScore
                            ">arrow_upward</mat-icon><mat-icon style="color: green" *ngIf="
                              currentMonthRiskScore < previousMonthRiskScore
                            ">arrow_downward</mat-icon>
                          <span style="font-size: 10px">
                            {{ percentageChange | number : "1.2-2" }}%
                          </span>
                        </b></span>
                    </h1>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Average Closing Time" | uppercase }}</h2>
                  <h4>Average time for an incident to close</h4>
                </div>
                <div>
                  <strong>
                    <h1>
                      {{ averageCloseTime + "mins" }}
                    </h1>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Critical Incident Count" | uppercase }}</h2>
                  <h4>Total Critical Incident reported this month</h4>
                </div>
                <div>
                  <strong>
                    <h1>
                      {{
                      criticalIncidentsCountNumber?.emergencySos +
                      criticalIncidentsCountNumber?.fire +
                      criticalIncidentsCountNumber?.intrusions +
                      criticalIncidentsCountNumber?.manual
                      }}
                    </h1>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Critical Risk Hour" | uppercase }}</h2>
                  <h4>Most active Time Span</h4>
                </div>
                <div>
                  <strong>
                    <h1>
                      {{ criticalRiskHour }}
                    </h1>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Total Claims" | uppercase }}</h2>
                  <h4>Total claim requests for the month</h4>
                </div>
                <div>
                  <strong>
                    <h1>
                      {{ currentMonthClaimTotal
                      }}<span><b><mat-icon style="color: red" *ngIf="
                              currentMonthClaimTotal >= previousMonthClaimTotal
                            ">arrow_upward</mat-icon><mat-icon style="color: green" *ngIf="
                              currentMonthClaimTotal < previousMonthClaimTotal
                            ">arrow_downward</mat-icon>
                          <span style="font-size: 10px">
                            {{ currentMonthClaimTotal | number : "1.2-2" }}%
                          </span>
                        </b></span>
                    </h1>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Total Claims Amount" | uppercase }}</h2>
                  <h4>Total claim amount for this month</h4>
                </div>
                <div>
                  <strong>
                    <h1>
                      {{ currentMonthClaimAmount
                      }}<span><b><mat-icon style="color: red" *ngIf="
                              currentMonthClaimAmount >= previousMonthClaimTotal
                            ">arrow_upward</mat-icon><mat-icon style="color: green" *ngIf="
                              currentMonthClaimAmount < previousMonthClaimTotal
                            ">arrow_downward</mat-icon>
                          <span style="font-size: 10px">
                            {{
                            percentageChangeClaimNumber | number : "1.2-2"
                            }}%
                          </span>
                        </b></span>
                    </h1>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </mat-grid-tile><mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Incident Analytics</mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title> Security </mat-panel-title>
                  <mat-panel-description>
                    <mat-icon>shield </mat-icon>
                    Score: 80
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <mat-card appearance="outlined">
                  <mat-card-header>
                    <mat-card-title>Poodle</mat-card-title>
                    <mat-card-subtitle>Non-sporting group</mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-actions align="end">
                    <button mat-button>Learn More</button>
                  </mat-card-actions>
                </mat-card>

                <mat-form-field>
                  <mat-label>Age</mat-label>
                  <input matInput type="number" min="1" />
                </mat-form-field>
              </mat-expansion-panel>
              <!-- <app-risk-bar-graph
                [chartHeight]="300"
                [chartData]="riskSingleData"
              ></app-risk-bar-graph> -->
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
  <br />
  <mat-divider></mat-divider>
  <br />
  <section>
    <mat-grid-list cols="1" rowHeight="120px">
      <mat-grid-tile rowspan="4">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Risk Profile</mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-risk-line-graph [chartHeight]="385" [riskQuestionsTotal]="riskQuestions"
                [rishGraphDetails]="rishGraphData"></app-risk-line-graph>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
  <br />
  <mat-divider></mat-divider>
  <br />
  <section>
    <mat-grid-list cols="1" rowHeight="120px">
      <mat-grid-tile rowspan="4">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Risk Status Data</mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-risk-breakdown-graph [chartHeight]="385"
                [breakdownRiskData]="riskAnalyticsStatusGraph"></app-risk-breakdown-graph>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
  <br />
  <mat-divider></mat-divider>
  <br />
  <section>
    <mat-grid-list [cols]="screenSize == ScreenType.Mobile ? 1 : 2" rowHeight="120px"><mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Risk Score Breakdown</mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-risk-pie-graph [chartHeight]="300" [chartData]="criticalIncidentsCounts"></app-risk-pie-graph>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
      <mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Risk Heatmap</mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-incident-heat-map [heatMapAssetData]="riskHeatMapData"></app-incident-heat-map>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
</div>